import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Page from 'src/shared-components/Page/Page';
import { BreadCrumbs } from 'src/shared-components/design-system/BreadCrumbs';
import NavigationWidget from 'src/shared-components/NavigationWidget/NavigationWidget';
import Constraints from 'src/shared-components/Constraints/Constraints';
import trns from './trns';
import PartnersContent from './PartnersContent';

const navigationOptions = [
  {
    id: '/partners/integration',
    label: <FormattedMessage {...trns.Integration} />
  },
  {
    id: '/partners/aboutApi',
    label: <FormattedMessage {...trns.aboutApi} />
  },
  {
    id: '/partners/loadingPharmacies',
    label: <FormattedMessage {...trns.loadingPharmacies} />
  },
  {
    id: '/partners/removalPharmacies',
    label: <FormattedMessage {...trns.removalPharmacies} />
  },
  {
    id: '/partners/loadingRemainingProds',
    label: <FormattedMessage {...trns.loadingRemainingProds} />
  },
  {
    id: '/partners/removalOfResidues',
    label: <FormattedMessage {...trns.removalOfResidues} />
  },
  {
    id: '/partners/orderStatus',
    label: <FormattedMessage {...trns.orderStatus} />
  },
  {
    id: '/partners/process',
    label: <FormattedMessage {...trns.process} />
  },

  {
    id: '/partners/changingDrugCart',
    label: <FormattedMessage {...trns.changingDrugList} />
  },
  {
    id: '/partners/creationOfTestReservation',
    label: <FormattedMessage {...trns.creationOfTestReservation} />
  },
  {
    id: '/partners/receivingNewBookings',
    label: <FormattedMessage {...trns.receivingNewBookings} />
  },

  {
    id: '/partners/updateBookingStatus',
    label: <FormattedMessage {...trns.updateBookingStatus} />
  },
  {
    id: '/partners/check',
    label: <FormattedMessage {...trns.check} />
  }
];

const PartnerContainer: FC = () => {
  const title = <FormattedMessage {...trns.toPartners} />;
  const [id, setId] = useState(navigationOptions[0].id);

  const handleIdChange = (idParam: string) => {
    setId(idParam);
  };

  const handleSelected = (idItem: string) => {
    return idItem === id;
  };

  return (
    <Page>
      <BreadCrumbs
        items={[
          {
            id: 'home',
            title: <FormattedMessage {...trns.homeBreadCrumb} />,
            href: '/'
          },
          {
            id: 'partners',
            title: <FormattedMessage {...trns.partners} />,
            href: '/partners'
          }
        ]}
      />
      <Constraints>
        <div className="flex w-full h-full relative pb-14">
          <div className="pt-10 sm:mr-[27px] flex flex-col space-y-6">
            <NavigationWidget
              navigationOptions={navigationOptions}
              title={title}
              handleIdChange={handleIdChange}
              handleSelected={handleSelected}
            />
          </div>
          <div className="flex w-full pt-10 px-5 xl:px-0">
            <PartnersContent id={id} />
          </div>
        </div>
      </Constraints>
    </Page>
  );
};

export default PartnerContainer;
